/* eslint-disable react/require-default-props */
import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
import Button from '../Button';
import ErrorBlock from '../common/ErrorBlock';
import { AUTH, CONFIRM_CANCEL, DECLINE_CANCEL } from '../../constants/strings';

const CancelForm = ({
  getAction,
  getOptions,
  onClose,
  onSubmit,
  invitationId,
  userId,
  text,
  rejected,
  intl: { formatMessage },
}) => {
  getAction(onSubmit);
  getOptions({ userId, invitationId });

  return (
    <div>
      <p>{text}</p>
      <If condition={rejected}>
        <ErrorBlock
          className="mv2"
          errors={formatMessage(AUTH.errors.common)}
        />
      </If>
      <Button className="mt3 mr2" raised color="primary" type="submit">
        <FormattedMessage {...CONFIRM_CANCEL} />
      </Button>
      <Button
        className="mt3"
        raised
        color="accent"
        onClick={onClose}
        type="button"
      >
        <FormattedMessage {...DECLINE_CANCEL} />
      </Button>
    </div>
  );
};

CancelForm.propTypes = {
  getAction: PropTypes.func,
  getOptions: PropTypes.func,
  onClose: PropTypes.func,
  onSubmit: PropTypes.func,
  invitationId: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.bool, // temp
  ]),
  userId: PropTypes.number,
  text: PropTypes.string,
  rejected: PropTypes.bool,
  intl: PropTypes.shape({
    formatMessage: PropTypes.func,
  }),
};

export default injectIntl(CancelForm);



// WEBPACK FOOTER //
// ./src/components/CircleList/CancelForm.jsx